'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _JSON$stringify = _interopDefault(require('babel-runtime/core-js/json/stringify'));
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$create = _interopDefault(require('babel-runtime/core-js/object/create'));
var $ = _interopDefault(require('jquery'));
var Twine = _interopDefault(require('twine'));
var Modal = _interopDefault(require('../modal.js'));
var FormsAPI = _interopDefault(require('../forms-api.js'));
var Analytics = _interopDefault(require('../../global/analytics.js'));
var Breakpoints = _interopDefault(require('../../global/breakpoints.js'));
require('./signup-form.js');

// Arguments: $el, template, options
var EMAIL_SUBSCRIBE_ENDPOINT = '/content-services/subscribers';
var EMAIL_SUBSCRIBE_DATA_EXTENSION_ID = '21262AE6-6D1B-4EE6-8448-017AF8238079';
var EMAIL_SUBSCRIBE_EVENT = 'Inline signup email capture';

var EMAIL_SELECTOR = '[name="signup[email]"]';
var INLINE_FORM_SELECTOR = 'form.js-signup-inline';
var HIDDEN_FORM_SELECTOR = '.signup--hidden';

// cache $signupForm html so bindings don't need to be re-attached
// This side-effect is bad, refactor this away so it doesn't happen on import.
// eslint-disable-next-line no-var, no-use-before-define
var $signupForm = $signupForm || $(HIDDEN_FORM_SELECTOR).first().detach();

function SignupModal() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  Modal.apply(this, args);

  this.Breakpoints = new Breakpoints();

  this.$inlineForm = $(INLINE_FORM_SELECTOR);
  this.$inlineForm.on('submit', this._onInlineSubmit.bind(this));

  // `this.options` is set by ShopifyMarketing.Modal
  this.$signupForm = this.options && this.options.$signupForm ? this.options.$signupForm : this.defaultSignupForm();
}

SignupModal.prototype = _Object$create(Modal.prototype);

SignupModal.prototype.defaultSignupForm = function () {
  return $signupForm;
};

SignupModal.prototype.render = function () {
  this.modalDom.$modal.html(this.template());
  this.modalDom.$modal.find('.signup-modal__content').append(this.$signupForm);
};

SignupModal.prototype.open = function (evt) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Modal.prototype.open.call(this, evt);

  var $modalForm = this.$signupForm.find('.signup-form').prop('id', 'SignupForm_modal');
  var namespace = $modalForm.data('namespace');

  Twine.bind(this.$signupForm.get(0)).refresh();

  this.modalForm = ShopifyMarketing.context[namespace];
  var hiddenFields = this.modalForm.getHiddenFields();

  if (options.theme) {
    hiddenFields.setField('theme', options.theme);
  }

  if (options.selectedPlan) {
    hiddenFields.setField('selected_plan', options.selectedPlan);
  }

  if (options.populate && this.inlineEmail) {
    this.modalForm.populateEmail(this.inlineEmail);
  } else if (this.Breakpoints.isDesktop()) {
    this.modalForm.focusOnField('email');
  }
};

SignupModal.prototype.close = function () {
  var _this = this;

  if (this.modalForm) {
    var gaData = _Object$keys(this.modalForm.fields).reduce(function (result, fieldName) {
      var field = _this.modalForm.fields[fieldName];
      result[fieldName] = field.state.filled;

      return result;
    }, {});

    gaData = _JSON$stringify(gaData);

    Analytics.track('threefield', 'modalclose', gaData);

    this.modalForm.eachField(function (field) {
      field.setState({
        error: false,
        focus: false,
        filled: false,
        success: false,
        pending: false,
        hint: '',
        value: '',
        errors: {}
      });
    });
  }

  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  Modal.prototype.close.apply(this, args);
};

SignupModal.prototype._onClick = function (evt) {
  evt.preventDefault();

  // Eventually we can build up this object and serialize all data
  // attributes passed into the modal
  var $trigger = $(evt.currentTarget);
  var modalData = {};
  var themeSlug = $trigger.data('theme-slug');
  var selectedPlan = $trigger.data('selected-plan');

  if (themeSlug) {
    modalData.theme = themeSlug;
  }

  if (selectedPlan) {
    modalData.selectedPlan = selectedPlan;
  }

  this.open(evt, modalData);
};

SignupModal.prototype._onInlineSubmit = function (evt) {
  evt.preventDefault();

  var $inlineForm = $(evt.currentTarget);
  this.inlineEmail = $inlineForm.find(EMAIL_SELECTOR).val();

  Analytics.track('threefield', 'submit', 'inline form');

  this.open(evt, { populate: true });

  this.$modalTrigger = $inlineForm.find('button[type="submit"]');
  this.captureEmail(this.inlineEmail);
};

SignupModal.prototype.captureEmail = function (email) {
  var valid = _Object$keys(FormsAPI.validateEmail(email)).length === 0;

  if (!valid) {
    Analytics.track(EMAIL_SUBSCRIBE_EVENT, 'Invalid email');
    return;
  }

  $.ajax({
    url: EMAIL_SUBSCRIBE_ENDPOINT,
    method: 'POST',
    data: {
      email: email,

      /* eslint-disable camelcase */
      data_extension_key: EMAIL_SUBSCRIBE_DATA_EXTENSION_ID,
      signup_page: window.location.href

      /* eslint-enable camelcase */
    }
  }).done(function () {
    Analytics.track(EMAIL_SUBSCRIBE_EVENT, 'Success');
  }).fail(function () {
    Analytics.track(EMAIL_SUBSCRIBE_EVENT, 'Error');
  });
};

module.exports = SignupModal;
